import { Component, inject } from '@angular/core';
import { CarteAtelierComponent } from '../../components/carte-atelier/carte-atelier.component';
import { ApiService } from '../../services/api.service';
import { Observable, of } from 'rxjs';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-prestation',
  imports: [CarteAtelierComponent, AsyncPipe],
  templateUrl: './prestation.component.html',
  styleUrl: './prestation.component.scss'
})
export class PrestationComponent {
  apiService:ApiService = inject(ApiService);
  route:ActivatedRoute = inject(ActivatedRoute);
  $ateliers:Observable<any[]> = of([]);
  $prestation :Observable<any> = of(null);

  ngOnInit():void {
    const prestationId:string | null = this.route.snapshot.paramMap.get('id');

    if(prestationId){
      this.$prestation = this.apiService.getTypeDePrestation(prestationId)
      this.$ateliers = this.apiService.getAteliersFromPresationType(prestationId);
    }
    
  }
}
